import React from "react";
import { AnimatedCard, ActionCard, ActionTitle } from "../ActionPlan/styles";

const STATUS_LABELS = {
  started: "Started",
  in_progress: "In progress",
  blocked: "Blocked",
  completed: "Completed",
};

export default function Review({ themeColors, actions, statuses, notes }) {
  return (
    <AnimatedCard isFadingOut={false}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        <h1 style={{
          fontFamily: 'Geist Variable, Geist, sans-serif',
          fontWeight: 500,
          fontSize: 'clamp(26px, 4vw, 34px)',
          margin: 0,
          color: 'oklch(.145 0 0)'
        }}>Review Check-In</h1>
        <p style={{ margin: '6px 0 0 0', color: '#4b5563', fontSize: 14 }}>
          Confirm the statuses and notes for each action before submitting.
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginTop: 8 }}>
          {actions.map((a) => (
            <ActionCard key={a.id}>
              <ActionTitle style={{ marginBottom: 6 }}>{a.title || 'Untitled action'}</ActionTitle>
              {a.description ? (
                <div style={{ color: '#374151', fontSize: 14, marginBottom: 8 }}>{a.description}</div>
              ) : null}
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 14, alignItems: 'center' }}>
                <div style={{ fontSize: 13, color: '#374151' }}>
                  <strong style={{ color: 'oklch(.145 0 0)' }}>Status: </strong>
                  {STATUS_LABELS[statuses[a.id]] || 'Not set'}
                </div>
              </div>
              {notes[a.id] ? (
                <div style={{ marginTop: 8, fontSize: 13, color: '#374151' }}>
                  <strong style={{ color: 'oklch(.145 0 0)' }}>Notes: </strong>{notes[a.id]}
                </div>
              ) : null}
            </ActionCard>
          ))}
        </div>
      </div>
    </AnimatedCard>
  );
}

